import { Component, inject, OnInit, ElementRef, ViewChild } from '@angular/core';
import { MessagingService } from '../../core/services/messaging.service';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../header/header.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { RouterModule } from '@angular/router';
import { TaskModalUpsertComponent } from '../../features/tasks/pages/task-modal-upsert/task-modal-upsert.component';
import { TaskModalService } from '../../features/tasks/services/task-modal.service';

@Component({
  standalone: true,
  imports: [CommonModule, RouterModule, HeaderComponent, SidebarComponent, TaskModalUpsertComponent],
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent implements OnInit {
  @ViewChild('mainContent') mainContent!: ElementRef;
  
  // The layout component owns the state
  isSidebarCollapsed = false;
  isMobile = false;
  showScrollTopButton = false;
  messagingService = inject(MessagingService);
  taskModalService = inject(TaskModalService);

  constructor() {
    this.messagingService.initialize();
  }

  // This method will be called by an event from the header
  toggleSidebar(): void {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }

  ngOnInit(): void {
    this.checkMobile();
    window.addEventListener('resize', () => this.checkMobile());
  }

  checkMobile() {
    this.isMobile = window.innerWidth <= 768;
    // On mobile, always start collapsed (hidden)
    if (this.isMobile && !this.isSidebarCollapsed) {
      this.isSidebarCollapsed = true;
    }
  }

  onScroll(event: Event): void {
    const element = event.target as HTMLElement;
    this.showScrollTopButton = element.scrollTop > 200;
  }

  scrollToTop(): void {
    this.mainContent.nativeElement.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}